export default __webpack_public_path__ + "static/media/service (2).e2c32cd2.jpg";